import React, { useEffect, useState } from 'react'
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// Account Views
// Refills Views
import Discount from '../../views/Discount'
import NewRefill from '../../views/NewRefill'
import Refills from '../../views/Refills'
// Dashboard View
// import DashBoard from '../../views/DashBoard'
import CardManagement from '../../views/Account/Employee/Cards/CardManagement'
import { AuthProvider } from '../../utils/login/context'
import Login from '../../views/Login/Login'

import { useCompanyData } from '../../utils/hooks/company/useCompanyData'
import ProtectedRoute from './ProtectedRoute'
import Header from '../../layout/Header'
import { RequestStatusProvider } from '../../utils/hooks/Context/RequestStatusContext'
import EmployeeDetails from '../../views/EmployeeDetails/EmployeeDetails'
import { LoadingProvider } from '../../utils/hooks/Context/LoadingContext'
import CompanyDetails from '../../views/Company/CompanyDetails/CompanyDetails'
import ManagementReports from '../../views/Company/ManagementReports'
import BranchAndCostCenter from '../../views/BranchAndCostCenter/BranchAndCostCenter'
import CreateAccount from '../../views/Account/Create/CreateAccount'
import EmployeeManagement from '../../views/Account/Employee/Management'
import PartnerRegister from '../../views/Account/PartnerRegister'
import Individual from '../../views/Account/PartnerRegister/Forms/Individual'
import Massive from '../../views/Account/PartnerRegister/Forms/Massive'
import AccountRequest from '../../views/Account/AccountRequest/AccountRequest'
import AccountStatus from '../../views/AccountStatus/AccountStatus'
import BranchOfficeDetails from '../../views/BranchAndCostCenter/BranchOfficeDetails'
import NewBranchOffice from '../../views/BranchAndCostCenter/NewBranchOffice'
import NewCostCenter from '../../views/BranchAndCostCenter/NewCostCenter'
import MassiveBranchOffice from '../../views/BranchAndCostCenter/MassiveBranchOffice'
import MassiveCostCenter from '../../views/BranchAndCostCenter/MassiveCostCenter'
import DashBoard from '../../views/DashBoard/DashBoard'
import useActivity from '../../utils/hooks/useActivity'
import CostCenterDetail from '../../views/BranchAndCostCenter/subViews/CostCenterDetail'
import MassiveTermination from '../../views/Account/MassiveTermination/MassiveTermination'
import Contacts from '../../views/Contacts/Contacts'
import ContactDetail from '../../views/Contacts/ContactDetail'
import Alerts from './../../views/Alerts/Alerts'
import ChangePassword from './../../views/ChangePassword/ChangePassword'
import { Password } from '../../views/password/Password'

const queryClient = new QueryClient()
function Router() {
  const [showMenu, setShowMenu] = useState(false)

  useCompanyData()
  useActivity()

  useEffect(() => {
    if (/^\/password\/update/gm.test(window.location.pathname)) {
      setShowMenu(false)
    } else setShowMenu(true)
  }, [])

  const RenderHeader = () => {
    if (showMenu) return <Header />
    else return <></>
  }

  return (
    <Box maxW="100vw" overflow="hidden" height="100%" minHeight="100%">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RequestStatusProvider>
            <LoadingProvider>
              <BrowserRouter>
                <RenderHeader />
                <Routes>
                  <Route
                    path="/password/update"
                    element={
                      <ProtectedRoute withoutPt withoutPx>
                        <Password />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <Outlet />
                      </ProtectedRoute>
                    }
                  >
                    <Route index element={<DashBoard />} />
                    <Route
                      path="contacts"
                      element={
                        <ProtectedRoute withoutPt>
                          <Outlet />
                        </ProtectedRoute>
                      }
                    >
                      <Route index element={<Contacts />} />
                      <Route path=":id" element={<ContactDetail />} />
                    </Route>

                    <Route
                      path="change-password"
                      element={<ChangePassword />}
                    />
                    <Route path="alerts" element={<Alerts />} />
                    <Route
                      path="/refills"
                      element={
                        <ProtectedRoute withoutPt>
                          <Outlet />
                        </ProtectedRoute>
                      }
                    >
                      <Route index element={<Refills />} />
                      <Route path="discount" element={<Discount />} />
                      <Route path="new" element={<NewRefill />} />
                    </Route>
                  </Route>
                  <Route
                    path="account"
                    element={
                      <ProtectedRoute>
                        <Outlet />
                      </ProtectedRoute>
                    }
                  >
                    <Route index element={<EmployeeManagement />} />
                    <Route
                      path="massive-termination"
                      element={<MassiveTermination />}
                    />
                    <Route path="create-account" element={<Outlet />}>
                      <Route index element={<CreateAccount />} />
                      <Route path="partner-register" element={<Outlet />}>
                        <Route index element={<PartnerRegister />} />
                        <Route path="individual" element={<Individual />} />
                        <Route path="massive" element={<Massive />} />
                      </Route>
                      <Route path="account-request" element={<Outlet />}>
                        <Route index element={<AccountRequest />} />
                      </Route>
                    </Route>
                    <Route
                      path="account-management"
                      element={<CardManagement />}
                    />

                    <Route
                      path="employee/:sEmpleado"
                      element={<EmployeeDetails />}
                    />
                  </Route>
                  <Route
                    path="company"
                    element={
                      <ProtectedRoute>
                        <Outlet />
                      </ProtectedRoute>
                    }
                  >
                    <Route index element={<CompanyDetails />} />
                    <Route path="reports" element={<ManagementReports />} />
                    <Route
                      path="branch-office-management"
                      element={
                        <ProtectedRoute withoutPt>
                          <Outlet />
                        </ProtectedRoute>
                      }
                    >
                      <Route index element={<BranchAndCostCenter />} />
                      <Route
                        path="new-branch-office"
                        element={<NewBranchOffice />}
                      />
                      <Route
                        path="massive-branch-office"
                        element={<MassiveBranchOffice />}
                      />
                      <Route
                        path="massive-cost-center"
                        element={<MassiveCostCenter />}
                      />
                      <Route
                        path="new-cost-center"
                        element={<NewCostCenter />}
                      />
                      <Route
                        path="office/:id"
                        element={<BranchOfficeDetails />}
                      />
                      <Route
                        path="costcenter/:id"
                        element={<CostCenterDetail />}
                      />
                    </Route>
                    <Route path="account-status" element={<AccountStatus />} />
                  </Route>
                </Routes>
              </BrowserRouter>
            </LoadingProvider>
          </RequestStatusProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Box>
  )
}

export default Router
